import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {InterventionTeamContactDto} from "../intervention-team-contact.dto";
import {Localization} from "../../../../common/enums/localization";
import {AppConfig} from "../../../../../config/app.config";
import {InterventionTeamContactResource} from "../intervention-team-contact-resource.service";
import {catchError, filter, finalize, switchMap, tap} from "rxjs/operators";
import {throwError} from "rxjs";
import {ConfirmDialogType, DialogService} from "@npm.chapps.com/chapps.common.angular.library";
import {TranslateService} from "@ngx-translate/core";
import {InterventionTeamResource} from "../../intervention-team.resource";
import {InterventionTeamDetailDto} from "../../teams/intervention-team-detail.dto";
import {TeamContactDialogComponent} from "../new-team-contact-dialog/team-contact-dialog.component";
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-contact-details',
  templateUrl: './contact-details.component.html',
  styleUrls: ['./contact-details.component.scss']
})
export class ContactDetailsComponent implements OnInit, OnChanges {

  @Input()
  public contact: InterventionTeamContactDto;
  @Output()
  public readonly onContactDeleted = new EventEmitter<InterventionTeamContactDto>();
  public saving = false;
  public teams: InterventionTeamDetailDto[];
  protected readonly Localization = Localization;
  private loadingTeams = false;

  constructor(
    public readonly config: AppConfig,
    private readonly contactResource: InterventionTeamContactResource,
    private readonly teamsResource: InterventionTeamResource,
    private readonly dialogs: DialogService,
    private readonly matDialogs: MatDialog,
    private readonly translate: TranslateService,
  ) {
  }

  public get canDelete(): boolean {
    return Array.isArray(this.teams) && this.teams.length === 0;
  }

  public get loading(): boolean {
    return this.loadingTeams;
  }

  public get fullName(): string {
    return `${this.contact?.firstName} ${this.contact?.lastName}`;
  }

  public get dateOfBirth(): Date {
    return new Date(this.contact.birthday);
  }

  async ngOnInit(): Promise<void> {
  }

  public async ngOnChanges(changes: SimpleChanges): Promise<void> {
    console.log('Changes', this.contact)
    if (this.contact) {
      await this.fetchTeams();
    }
  }

  public toggleFavorite(): void {
    this.update({favorite: !this.contact.favorite}).subscribe();
  }

  public confirmDelete(): void {
    this.dialogs.confirm({
      confirmText: Localization.Delete,
      cancelText: Localization.Cancel,
      icon: "fa-exclamation-triangle",
      showCancel: true,
      title: "",
      text: this.translate.instant(Localization.AreYouSureYouWantToDeleteContactTo, {value: this.fullName}),
      type: ConfirmDialogType.Danger,
    }).pipe(filter(Boolean), switchMap(() => this.deleteContact()))
      .subscribe()
  }

  public edit(): void {
    const data = this.contact;
    this.matDialogs.open(TeamContactDialogComponent, {panelClass: 'full-bleed', data})
      .afterClosed().pipe(filter(Boolean))
  }

  private update(data?: Partial<InterventionTeamContactDto>) {
    this.saving = true;
    const original = clone(this.contact);
    Object.assign(this.contact, data);
    return this.contactResource.update(this.contact).pipe(
      catchError(error => {
        Object.assign(this.contact, original);
        return throwError(error);
      }),
      finalize(() => this.saving = false),
    )
  }

  private async fetchTeams(): Promise<void> {
    this.loadingTeams = true;
    const teamsResponse = await this.teamsResource.find({contactId: this.contact.id}).toPromise();
    this.teams = teamsResponse.items
    this.loadingTeams = false;
  }

  private deleteContact() {
    return this.contactResource.delete(this.contact).pipe(
      tap(() => this.onContactDeleted.emit(this.contact))
    );
  }
}

function clone<Type>(object: Type): Type {
  return JSON.parse(JSON.stringify(object));
}
